module.exports = __webpack_public_path__ + "media/images/Update-0fdca1964f92f887602d00a3fbdbb30c.svg";